import QuestionnaireYesNo from './QuestionnaireYesNo'

export {
  QuestionnaireYesNo
}


// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireYesNo/index.js